/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ServerError, useMutation } from '@apollo/client'
import { Step1Sub1 } from './Step1Sub1'
import Alert from '../../../../_metronic/partials/alert'
import mutations from '../../../../setup/graphql/mutations'
import { fetchStop } from '../../../../redux/actions/common'
import {
  setLoanApplication,
  setLoanSubStep,
  setLoanEligibility,
  setLoanStep,
} from '../redux/actions'

const Step1: FC = ({
  // prevStep,
  // nextStep,
  updateApplication,
  getApplication,
}: any) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  const [mobileNo, setMobileNo] = useState<any>('')
  const agentCode = localStorage.getItem('agentCode')
  // const [subStep, setSubStep] = useState(1);

  const loanSubStep = useSelector((state: any) => state.loan.loanSubStep)
  const loanApplication = useSelector((state: any) => state.loan.loanApplication)

  const [createApplication, onSuccessCreateApplicaton] = useMutation(mutations.CREATE_APPLICATION)

  const [createLoanElgibility, onSuccessCreateLoanElgibility] = useMutation(
    mutations.CREATE_LOAN_ELIGIBILITY
  )

  useEffect(() => {
    if (loanApplication !== null) {
      setMobileNo(loanApplication.mobileNumber)
    }
  }, [loanApplication])

  useEffect(() => {
    if (onSuccessCreateApplicaton.called && !onSuccessCreateApplicaton.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateApplicaton.data) {
        const { createApplication } = onSuccessCreateApplicaton.data
        const mobileNo = createApplication.mobileNumber

        /**
         * Resetting Mail Sent Flag on New Application Creation
         */
        dispatch(setLoanApplication(createApplication))
        localStorage.removeItem('errorLogged')
        setMobileNo(mobileNo)
        if (createApplication && createApplication?.companyUEN) {
          if (
            ['stage', 'sandbox', 'dev', 'local'].includes(localStorage.getItem('env') as string)
          ) {
            ;(async () => {
              const response = await import(
                `../../../../utils/custom/${createApplication.companyUEN}/step1Sub3.json`
              )
              const eligibilityData: any = response.default
              if (eligibilityData) {
                // Dispatch the action to update the loan eligibility in the Redux store
                dispatch(setLoanEligibility(eligibilityData))
              }
            })()
          }
          localStorage.setItem('companyUEN', createApplication.companyUEN)

          setTimeout(() => {
            history.push(`/agent-application/${createApplication.id}?step=2`)
            dispatch(setLoanStep(2))
            dispatch(setLoanSubStep(0))
          }, 500)
        }

        createLoanElgibility({
          variables: {
            data: {
              businessMobileNumber: createApplication?.mobileNumber,
              businessEmailAddress: createApplication?.businessOwnerEmail,
              application: {
                connect: {
                  id: createApplication?.id,
                },
              },
            },
          },
        })

        // sendOTP({
        //   variables: {
        //     mobileNo,
        //     isApplicantOrShareholder: true,
        //   },
        // })
        // localStorage.setItem('loanApplicationId', createApplication.id);
        // history.push(`/application/${createApplication.id}`)
        onSuccessCreateApplicaton.reset()
      } else {
      }

      if (onSuccessCreateApplicaton.error) {
        const { networkError } = onSuccessCreateApplicaton.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [
    onSuccessCreateApplicaton.loading,
    onSuccessCreateApplicaton.data,
    onSuccessCreateApplicaton.error,
    onSuccessCreateApplicaton.called,
  ])

  useEffect(() => {
    if (onSuccessCreateLoanElgibility.called && !onSuccessCreateLoanElgibility.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateLoanElgibility.data) {
        if (onSuccessCreateLoanElgibility.data) {
          const { createLoanEligibility } = onSuccessCreateLoanElgibility.data

          dispatch(setLoanEligibility(createLoanEligibility))
          onSuccessCreateLoanElgibility.reset()
        }
      } else {
      }

      if (onSuccessCreateLoanElgibility.error) {
        const { networkError } = onSuccessCreateLoanElgibility.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [
    onSuccessCreateLoanElgibility.loading,
    onSuccessCreateLoanElgibility.data,
    onSuccessCreateLoanElgibility.error,
    onSuccessCreateLoanElgibility.called,
  ])

  return (
    <>
      {loanSubStep === 1 && (
        <Step1Sub1
          createApplication={createApplication}
          updateApplication={updateApplication}
          mobileNo={mobileNo}
          agentCode={agentCode}
        />
      )}

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </>
  )
}

export { Step1 }
